import { ActionTree } from "vuex";
import { IAppState } from "./state";
import { loadLanguageAsync } from "@/i18n";
import {
    SET_LANG,
    UPDATE_TIME,
    LOAD,
    REFRESH_SASTOKEN,
} from "./mutations-types";
import { AxiosResponse } from "axios";
import { apiClient } from "@/services";
import moment from "moment";

export const actions: ActionTree<IAppState, any> = {

    toggleFullScreen(): void {
        const doc: any = document;

        if (!doc.fullscreenElement && !doc.webkitFullscreenElement) {
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            }
            else if (doc.documentElement.webkitRequestFullScreen) {
                doc.documentElement.webkitRequestFullScreen();
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            }
            else if (doc.webkitExitFullscreen) {
                doc.webkitExitFullscreen();
            }
        }
    },

    async setLang(context, lang: string): Promise<any> {
        await loadLanguageAsync(lang);
        context.commit(SET_LANG, lang);
    },

    async start(context) {
        setInterval(() => {
            context.commit(UPDATE_TIME);
        }, 1000 * 60);

        const payload = {
            now: moment().toISOString(true),
        };

        // our lamba to get the sasToken from API
        const fn = async () => await apiClient.post("/refreshToken", payload).then(response => {
            context.commit(REFRESH_SASTOKEN, response.data);
        });

        // exec at app startup
        fn();

        // exec evry 28 minutes (2 minutes gap to avoid strange bug)
        setInterval(async () => {
            payload.now = moment().toISOString(true);

            fn();
        }, 1000 * 60 * 28); // 28 minutes
    },

    load(context) {
        context.commit(LOAD);
    },
};
